import style from './index.module.scss';

export const NavMenu = ({ menu }) => {
    return (
        <div className={style.nav}>
            {menu &&
                Object.values(menu).map((menuItem, id) => {
                    return (
                        <a href={menuItem.url} className={style.item} key={id}>
                            <span className={style.menuItem}>{menuItem.title}</span>
                        </a>
                    );
                })}
        </div>
    );
};
